import { currentUser } from "./user";
import { app } from "../firebase";
import { writable } from "svelte/store";
import { handleError } from "../common/error";

const store = {
    articles: writable(),
    courses: writable(),
    categories: writable(),
};

const collections = Object.keys(store);

let lastUser;
let subscriptions = [];

const db = app.firestore();

currentUser.subscribe((user) => {
    if (!user) return closeSubscription();
    if (user.email === (lastUser && lastUser.email) || !user.active) return;
    startSubscription(user);
});

function closeSubscription() {
    lastUser = null;
    collections.forEach((collection) => store[collection].set(null));
    subscriptions.forEach((subscription) => subscription());
}

function startSubscription(user) {
    closeSubscription();
    lastUser = user;

    subscriptions = collections.map((collection) =>
        db.collection(collection).onSnapshot((snapshot) => {
            store[collection].set(
                snapshot.docs.map((doc) => {
                    const data = doc.data();
                    return {
                        ...data,
                        uid: doc.id,
                    };
                })
            );
        }, handleError)
    );
}

export const articles = store.articles;
export const courses = store.courses;
export const categories = store.categories;
